'use strict'

jQuery( document ).ready( function ( $ ) {
	const owltwitter = $( '.twitter__carousel' )

	var col_count = owltwitter.attr( 'data-col' )
	var alt_col_count = $( '.twitter__carousel ' ).data( 'colcount' )
	if ( alt_col_count == '' ) {
		if ( col_count == false || col_count == 0 ) {
			col_count = 3
		}
	} else {
		col_count = alt_col_count
	}

	/**
	 * Set the image inside header position of the tweet AFTER click, so we're not preloading all the images of the tweets on page load.
	 * Kinda like lazy loading, but an even lazyer way of doing it
	 */
	function owlResetImages() {
		// Populate tweets with images on first load
		$( '.twitter__widget--image' ).each( function () {
			if ( $( this ).parents( '.owl-item' ).hasClass( 'active' ) ) {
				$( this ).css( { 'background-image': 'url(' + $( this ).attr( "data-img" ) + ')' } )
				$( this ).next().css( { 'background-image': 'url(' + $( this ).attr( "data-img" ) + ')' } )
			}
		} )
	}

	// Checking for twitter carousels existence - stops errors where Owl complains it cant find an instance of itself on every page
	if ( owltwitter.length ) {
		owltwitter.owlCarousel( {
			'loop': true,
			responsiveClass: true,
			margin: 20,
			navText: [ "<i class='far fa-chevron-left'></i>", "<i class='far fa-chevron-right'></i>" ],
			responsive: {
				0: {
					items: 1,
					nav: true,
				},
				600: {
					items: 2,
					nav: false,
				},
				1000: {
					items: col_count,
					nav: true,
				},
			},
			onNext: owlResetImages,
			//onInitialized: owlResetImages
		} )
	}

	$( document ).on( 'click', '.owl-nav div', function () {
		owlResetImages()
	} )

	// Defer first image load to give browser a chance to load the rest of the page
	// Assume 3 seconds as average page load speed
	setTimeout( function () {
		owlResetImages()
	}, 3000 )
} )
